/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf
     */
    'cardType': GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOfCardTypeEnum = typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOfCardTypeEnum[keyof typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOfCardTypeEnum];


